export default __webpack_public_path__ + "static/media/logo.1906f12b.gif";